import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const EditEntityContainer = Loadable({
    loader: () => import('../../Containers/Entity/EditEntityContainer'),
    loading: Loading,
});

const entityRoutes = [
    { path: '/entity', exact: true, name: 'Mi Empresa', component: EditEntityContainer },
];

export default entityRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/entity.js